  export const carouselDivStyle = {
    margin: "0 auto",
    display: "flex",
    justifyContent: "center",

    '& .carousel': {
      display: 'flex',
    }
  }

  export const carouselImageStyle = {
    height: "240px",
    objectFit: "contain",
    margin: " 0 20px 0 0",
    borderRadius: "16px",
    cursor: "pointer",
  }

  export const carouselWrapperStyle = {
    whiteSpace: "nowrap",
    display: "flex",
    overflowX: "scroll",
    width: "100%",
    overflowY: "hidden",
  }


  export const largeIconStyle = {
    transform: "scale(2)",
    cursor: "pointer",
  }

export const arrowWrapperStyle = (theme) => ({
    borderRadius: "50%",
    padding: "20px",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    [theme.breakpoints.down('sm')]: {
        padding: 0,
        '&:hover': {
            boxShadow: 'none'
        }
    }
});
